export default {
  text: 'Du bist wieder online',
};
